(() => {
  const stripeColors = [null, ['#bc1024'], ['#ed6b16'], ['#e9b514'], ['#168047'], ['#33a8e7'], ['#174990'], ['#72339b'], ['#f4f4ef'], ['#48a5de','#153c89','#d12736'], ['#1a1b1c','#c8262c','#ddb83d'], ['#14934f','#f5f5f1','#d52b34']];
  const blackTwill = 'https://cdn.shopify.com/s/files/1/0780/0356/8812/files/shop-carbon-parts-wheel-black-twill-original-weave-20260924.png?v=1790245261';
  const stitchColors = [['#202126'], ['#f5f5f1'], ['#c92731'], ['#e97920'], ['#e6b31f'], ['#17854d'], ['#49a6dd'], ['#1c4a93'], ['#753e9c'], ['#48a5de','#153c89','#d12736'], ['#1a1b1c','#c8262c','#ddb83d'], ['#14934f','#f5f5f1','#d52b34']];
  function start(root) {
    if (root.dataset.fPreviewInitialized) return;
    root.dataset.fPreviewInitialized = 'true';
    const viewer = root.querySelector('[data-scdwb-live-model]');
    const status = root.querySelector('[data-scdwb-live-status]');
    const fields = JSON.parse(root.querySelector('[data-scdwb-config]').textContent).catalog.fields;
    const assets = JSON.parse(root.dataset.assetMap || '{}');
    assets['material-twill-0.jpg'] = blackTwill;
    assets['material-perf-0.jpg'] = 'https://cdn.shopify.com/s/files/1/0780/0356/8812/files/shop-carbon-parts-wheel-final-material-perf-0-20260923.png?v=1790232078';
    assets['material-smooth-0.jpg'] = 'https://cdn.shopify.com/s/files/1/0780/0356/8812/files/shop-carbon-parts-wheel-final-material-smooth-0-20260923.png?v=1790231849';
    const nonLedURL = new URL(viewer.getAttribute('src'), location.href).href;
    const ledURL = root.dataset.ledModelUrl ? new URL(root.dataset.ledModelUrl, location.href).href : nonLedURL;
    let activeURL = nonLedURL;
    const cache = new Map();
    let state = {}, revision = 0;
    const id = key => String(state[key] ?? '0');
    const material = name => viewer.model?.getMaterialByName('SCP F - ' + name);
    const texture = (key, role, scale = 1) => {
      const raw = assets['material-' + key] || assets[key];
      const url = new URL(raw, location.href);
      if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com') throw new Error('Missing builder texture');
      const cacheKey = role + ':' + url.href + ':' + scale;
      if (!cache.has(cacheKey)) cache.set(cacheKey, viewer.createTexture(url.href).then(map => {
        map.sampler.setWrapS(10497);
        map.sampler.setWrapT(10497);
        map.sampler.setScale({u: scale, v: scale});
        return map;
      }));
      return cache.get(cacheKey);
    };
    const finish = (name, map, tint = '#ffffff', roughness = .22, coat = 0) => {
      const part = material(name);
      if (!part) throw new Error('Missing F-Chassis material: ' + name);
      part.setAlphaMode('OPAQUE');
      part.pbrMetallicRoughness.baseColorTexture.setTexture(map);
      part.pbrMetallicRoughness.setBaseColorFactor(tint);
      part.pbrMetallicRoughness.setMetallicFactor(0);
      part.pbrMetallicRoughness.setRoughnessFactor(roughness);
      part.setClearcoatFactor?.(coat);
      part.normalTexture?.setTexture(null);
      return part;
    };
    async function update() {
      const request = ++revision;
      delete root.dataset.previewReadyState;
      status.textContent = 'Updating 3D preview…';
      const desiredURL = state.led === '1' ? ledURL : nonLedURL;
      if (activeURL !== desiredURL) {
        activeURL = desiredURL;
        cache.clear();
        viewer.style.opacity = '.35';
        viewer.src = desiredURL;
        return;
      }
      if (!viewer.model || !viewer.loaded) return;
      try {
        const family = id('carbon');
        const carbonKey = family === '1' ? `forged-${id('forged')}.jpg` : family === '2' ? `honey-${id('honey')}.jpg` : `twill-${id('twill')}.jpg`;
        const trimKey = id('trimCarbonFinish') === '1' ? carbonKey : 'twill-0.jpg';
        const leather = String(state.leather ?? '1');
        const colorField = leather === '0' ? 'smoothColor' : leather === '2' ? 'alcColor' : 'perfColor';
        const color = fields.find(f => f.id === colorField)?.options.find(o => o.id === id(colorField));
        const gripKey = color?.materialBase || `${leather === '0' ? 'smooth' : leather === '2' ? 'alc' : 'perf'}-${id(colorField)}.jpg`;
        const customTrim = id('trim') === '1';
        const trimMaterial = id('trimMaterial');
        const shellKey = trimMaterial === '0' ? 'alc-0.jpg' : trimMaterial === '2' ? 'smooth-0.jpg' : trimKey;
        const alcCover = id('airbag') === '1' && id('airbagMaterial') === '1';
        const stitchIndex=Number(id('stitch'));
        const stitchMap=['bmw','german','italian'][stitchIndex-9] || 'neutral';
        const [carbon, trim, paddle, grip, shell, cover, stitchTexture] = await Promise.all([
          texture(carbonKey, 'rim'), texture(trimKey, 'trim'), texture('twill-0.jpg', 'paddles'),
          texture(gripKey, 'grips', leather === '1' ? 1 : 7.8326 / 48.3027),
          texture(shellKey, 'shell', trimMaterial === '1' ? 1 : 7.8326 / 74.6464),
          texture(alcCover ? 'alc-0.jpg' : 'smooth-0.jpg', 'cover'),
          texture('stitch-mask-'+stitchMap+'.png','grip-stitch')
        ]);
        if (request !== revision || activeURL !== desiredURL || !viewer.loaded) return;
        finish('carbon rim', carbon, '#ffffff', .22, 1);
        finish('paddle shifters', paddle, '#ffffff', .22, .18);
        finish('side grips', grip, color?.tint || '#ffffff', leather === '2' ? .88 : leather === '0' ? .68 : .58);
        finish('outer trim shell', customTrim ? shell : null, customTrim ? '#ffffff' : '#17191b', customTrim && trimMaterial === '1' ? .22 : trimMaterial === '0' ? .9 : .65, customTrim && trimMaterial === '1' ? .18 : 0);
        const center = material('chrome center trim') || material('middle trim');
        center.pbrMetallicRoughness.baseColorTexture.setTexture(null);
        center.pbrMetallicRoughness.setBaseColorFactor('#c8cdd2');
        center.pbrMetallicRoughness.setMetallicFactor(.85);
        center.pbrMetallicRoughness.setRoughnessFactor(.22);
        const insert = finish('no-hole center insert', null, '#c8cdd2', .22);
        insert.pbrMetallicRoughness.setMetallicFactor(.85);
        const showInsert = customTrim && id('trimStyle') === '0';
        insert.setAlphaMode(showInsert ? 'OPAQUE' : 'BLEND');
        insert.pbrMetallicRoughness.setBaseColorFactor(showInsert ? '#c8cdd2' : [1, 1, 1, 0]);
        finish('airbag cover', cover, '#ffffff', alcCover ? .96 : .65);
        const rimThreads = stitchColors[Number(id('stitch'))] || stitchColors[0];
        const lacing=material('grip stitching');
        if(lacing) {
          lacing.setAlphaMode('BLEND');
          lacing.pbrMetallicRoughness.baseColorTexture.setTexture(stitchTexture);
          lacing.pbrMetallicRoughness.setBaseColorFactor(stitchIndex>=9?'#ffffff':rimThreads[0]);
          lacing.pbrMetallicRoughness.setRoughnessFactor(.72);
        }
        const coverThreads = [['#c92731'],['#f4f4f1'],['#1c1c1c'],['#49a6dd','#194b93','#c92731'],['#1c1c1c']][Number(id('airbagStitch'))] || ['#1c1c1c'];
        for (let lane=0; lane<3; lane++) {
          const rimThread=material('rim stitch '+lane);
          if(rimThread) {
            rimThread.pbrMetallicRoughness.setBaseColorFactor(rimThreads[lane % rimThreads.length]);
            rimThread.pbrMetallicRoughness.setRoughnessFactor(.72);
          }
          const coverThread=material('airbag stitch '+lane);
          if(coverThread) {
            const visible=state.airbag==='1';
            coverThread.setAlphaMode(visible?'OPAQUE':'BLEND');
            coverThread.pbrMetallicRoughness.setBaseColorFactor(visible?coverThreads[lane % coverThreads.length]:[0,0,0,0]);
            coverThread.pbrMetallicRoughness.setRoughnessFactor(.72);
          }
        }
        const led = state.led === '1';
        const palette = stripeColors[Number(id('stripe'))];
        for (const role of ['rim', 'housing', 'lens']) {
          for (let lane = 0; lane < 3; lane++) {
            const stripe = material('stripe ' + role + ' ' + lane);
            if (!stripe) continue;
            const visible = Boolean(palette) && (role === 'rim' || !led);
            stripe.setAlphaMode(visible ? 'OPAQUE' : 'BLEND');
            stripe.pbrMetallicRoughness.setBaseColorFactor(visible ? palette[(2 - lane) % palette.length] : [1,1,1,0]);
          }
        }
        if (material('display housing')) {
          if (led) {
            finish('display housing', null, '#050608', .28);
            const lens = finish('display lens', null, '#050608', .12);
            lens.setAlphaMode('BLEND');
            lens.pbrMetallicRoughness.setBaseColorFactor([.005, .006, .008, .045]);
          } else {
            finish('display housing', carbon, '#ffffff', .22, 1);
            finish('display lens', carbon, '#ffffff', .22, 1);
          }
          for (const [name, factor] of [['SCP F - LCD readout', [0,0,0,1]], ['F82 LED green', [.001,.5,.012,1]], ['F82 LED amber', [.75,.21,.001,1]], ['F82 LED red', [.65,.001,.001,1]]]) {
            const part = viewer.model.getMaterialByName(name);
            if (!part) throw new Error('Missing F-Chassis display material');
            part.setAlphaMode(led ? 'OPAQUE' : 'BLEND');
            part.pbrMetallicRoughness.setBaseColorFactor(led ? factor : [0, 0, 0, 0]);
          }
        }
        viewer.style.opacity = '1';
        root.dataset.fActiveModel = led ? 'led' : 'non-led';
        status.textContent = '3D preview updated to your swatches.';
        root.dataset.previewReadyState = JSON.stringify(state);
        root.dispatchEvent(new CustomEvent('scdwb:preview-ready', {detail: {state: {...state}}}));
      } catch (error) {
        if (request !== revision) return;
        delete root.dataset.previewReadyState;
        viewer.style.opacity = '1';
        status.textContent = '3D swatch update unavailable; product photos remain available.';
        console.error('F-Chassis preview update failed', error);
      }
    }
    root.addEventListener('scdwb:selection', event => { state = {...event.detail.state}; update(); });
    viewer.addEventListener('load', () => { cache.clear(); update(); });
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-scdwb-view]');
      if (!button) return;
      const showModel = button.dataset.scdwbView === '3d';
      root.querySelector('[data-scdwb-live-panel]').hidden = !showModel;
      root.querySelector('[data-scdwb-photo-panel]').hidden = showModel;
      root.querySelectorAll('[data-scdwb-view]').forEach(b => {
        const selected = b === button;
        b.setAttribute('aria-pressed', String(selected));
        b.classList.toggle('scdwb-active', selected);
      });
    });
    const panel = root.querySelector('[data-scdwb-live-panel]');
    const fullscreen = root.querySelector('[data-scdwb-fullscreen]');
    if (document.fullscreenEnabled && panel.requestFullscreen) {
      fullscreen.hidden = false;
      fullscreen.addEventListener('click', () => document.fullscreenElement === panel ? document.exitFullscreen() : panel.requestFullscreen());
    }
    update();
  }
  document.querySelectorAll('scd-wheel-builder[data-model-profile="f-chassis"]').forEach(start);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('scd-wheel-builder[data-model-profile="f-chassis"]').forEach(start));
})();
